import React from 'react';

const MentorTable = ({ title, rows, all }) => (
  <div className="reportbox-content">
    <h4>{title}</h4>
    <div className="line"></div>
    <table className="table table-hover table-bordered">
      <thead>
      <tr>
        <th>№</th>
        <th>Имя ментора</th>
        <th>Направления экспертизы</th>
        <th>Заявки в работе</th>
      </tr>
      </thead>
      <tbody>
      {rows.length > 0 ? rows.map((mentor,idx) => (
        <tr key={idx}>
          <td className='label-num-cell'><span className="no-desktop">№&nbsp;</span> {idx+1}</td>
          <td><span className="no-desktop">Имя ментора:&nbsp;</span> {[mentor.mentor_last_name, mentor.mentor_first_name].join(' ')}</td>
          <td><span className="no-desktop">Направления экспертизы:&nbsp;</span> {mentor.mentor_directions.join(', ')}</td>
          <td><span className="no-desktop">Заявки в работе:&nbsp;</span> {all.filter(proc => proc.mentor_email === mentor.sk_user_email && proc.mentor_confirmed).length}</td>
        </tr>
      )) : (
        <tr><td colSpan={7} style={{ textAlign: 'center' }}>Нет записей</td></tr>
      )}
      </tbody>
    </table>
  </div>
);

export default MentorTable;
